import React from 'react';
import { createIcon } from './create-icon';
import './icon-trash.scss';

export const IconTrash = createIcon(<div className="icon-trash" />);
